"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepCircle = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var StepCircularProgress_1 = require("./StepCircularProgress");
var icons_1 = require("../../icons");
var StepCircle = function (_a) {
    var className = _a.className, completionStatus = _a.completionStatus, progress = _a.progress, showNumberOnComplete = _a.showNumberOnComplete, size = _a.size, status = _a.status, step = _a.step;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)('step-circle', className, progress !== undefined && 'step-circle-progress'), "data-testid": "step-circle" }, { children: [progress !== undefined && completionStatus !== 'complete' && !size && ((0, jsx_runtime_1.jsx)(StepCircularProgress_1.StepCircularProgress, { progress: progress, size: 30 })), status !== 'normal' && !size && (0, jsx_runtime_1.jsx)(icons_1.Alert16, { "data-testid": "alert-icon" }), status !== 'normal' && size === 'sm' && (0, jsx_runtime_1.jsx)(icons_1.Alert24, { "data-testid": "alert-icon" }), status === 'normal' &&
                size !== 'xs' &&
                (completionStatus === 'complete' && !showNumberOnComplete ? ((0, jsx_runtime_1.jsx)(icons_1.Check16, { "data-testid": "check" })) : (!size && (0, jsx_runtime_1.jsx)("span", __assign({ className: "step-number" }, { children: step }))))] })));
};
exports.StepCircle = StepCircle;
